import React, { createContext } from 'react';
import { db } from '../firebaseConfig';

export const PostStore = createContext();

export class PostStoreProvider extends React.Component {
    state = {
        posts: []
    };

    componentDidMount() {
        const prods = this.state.posts;
        db.collection('posts').orderBy('PostDate', 'desc').limit(9).onSnapshot(snapshot => {
            let changes = snapshot.docChanges();
            changes.forEach(change => {
                if (change.type === 'added') {
                    prods.push({
                        PostId: change.doc.id,
                        PostTitle: change.doc.data().PostTitle,
                        PostDescription: change.doc.data().PostDescription,
                        PostImg: change.doc.data().PostImg
                    })
                }
                this.setState({
                    posts: prods
                })
            })
        })
    }

    render() {
        return(
            <PostStore.Provider value={{ posts: [...this.state.posts] }}>
                { this.props.children }
            </PostStore.Provider>
        );
    }
}